import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import StoreFinder from '../customer_pages/_store-finder';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('store-finder-root');

  const props = JSON.parse(root.dataset.props);

  hydrateRoot(root, <StoreFinder {...props} />);
});
